const rankingItems = [
  {
    rank: 1,
    title: '异界触手录',
    tag: '异世界冒险',
    heat: '128.6万',
    update: '今日更新第128话',
    medal: '🥇',
  },
  {
    rank: 2,
    title: '触手都市',
    tag: '都市奇幻',
    heat: '115.2万',
    update: '今日更新第95话',
    medal: '🥈',
  },
  {
    rank: 3,
    title: '触手纪元',
    tag: '科幻机甲',
    heat: '98.7万',
    update: '昨日更新第73话',
    medal: '🥉',
  },
  {
    rank: 4,
    title: '暗夜触手',
    tag: '悬疑惊悚',
    heat: '87.3万',
    update: '今日更新第56话',
    medal: '',
  },
  {
    rank: 5,
    title: '触手学园',
    tag: '校园搞笑',
    heat: '76.1万',
    update: '昨日更新第112话',
    medal: '',
  },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 scroll-mt-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
          热度排行
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          触手漫画本周热度排行榜 TOP5
        </p>
        <div className="space-y-3">
          {rankingItems.map((item) => (
            <a
              key={item.rank}
              href="#cards"
              className="flex items-center gap-4 bg-background-100 rounded-xl p-4 md:p-5 border border-background-200/60 hover:border-primary-200 transition-colors cursor-pointer group"
            >
              <div className="w-10 h-10 flex items-center justify-center text-xl font-heading font-bold text-foreground-500 flex-shrink-0">
                {item.medal || item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="text-sm md:text-base font-heading font-bold text-foreground-800 group-hover:text-primary-500 transition-colors">
                    {item.title}
                  </h3>
                  <span className="px-2 py-0.5 bg-accent-100 text-accent-700 text-xs rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <p className="text-xs text-foreground-500 mt-1">{item.update}</p>
              </div>
              <div className="text-right flex-shrink-0">
                <div className="text-sm md:text-base font-bold text-accent-500 flex items-center gap-1">
                  <i className="ri-fire-line text-xs"></i>
                  {item.heat}
                </div>
                <span className="text-xs text-foreground-400">本周热度</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}